import { all } from 'redux-saga/effects';
import authSaga from './sagas/authSaga';
import {watchFeedSaga} from './sagas/feedSaga';
import boardSaga from './sagas/boardSagas'
import commentSaga     from './sagas/commentSagas';
import mypageListsSaga from "./sagas/mypageListsSaga";
import alertsSaga      from './sagas/alertsSaga';
import mainSaga from './sagas/mainSaga';
import myPageSaga from './sagas/myPageSaga';
import adminUsersSaga from './sagas/adminUsersSaga';

export default function* rootSaga() {
    yield all([
        authSaga(),
        watchFeedSaga(),
        boardSaga(),
        commentSaga(),
        mypageListsSaga(),
        alertsSaga(),
        mainSaga(),
        myPageSaga(),
        adminUsersSaga(),
    ]);
}
